import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { UserData } from '../services/user.service';
import { AuthModalService } from '../shared/auth-modal/auth-modal.service';
import { map, take, timeout, catchError, filter, of as rxOf } from 'rxjs';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const authModalService = inject(AuthModalService);

  console.log('AuthGuard: Checking authentication...');
  
  // Check if we already have a user
  const currentUser = authService.currentUserValue;
  
  if (currentUser !== undefined) {
    if (currentUser) {
      console.log('AuthGuard: User already authenticated:', currentUser.uid);
      return true;
    } else {
      console.log('AuthGuard: User definitely not authenticated. Opening Auth Modal.');
      authModalService.openSignIn(state.url);
      return false; // Prevent navigation and keep user on the same page
    }
  }

  console.log('AuthGuard: Waiting for Firebase to initialize...');
  
  // Wait for Firebase to initialize (emits non-undefined value)
  return authService.userProfile$.pipe(
    filter((profile: UserData | null | undefined): profile is UserData | null => profile !== undefined),
    take(1),
    timeout(5000),
    map((profile: UserData | null) => {
      console.log('AuthGuard: User state after initialization:', profile ? `Authenticated (${profile.uid})` : 'Not authenticated');
      if (profile) {
        return true;
      } else {
        console.log('AuthGuard: User not authenticated after init. Opening Auth Modal.');
        authModalService.openSignIn(state.url);
        return false;
      }
    }),
    catchError((err) => {
      console.error('AuthGuard: Timeout or error:', err);
      authModalService.openSignIn();
      return rxOf(false);
    })
  );
};
